
import { Component } from 'nuxt-property-decorator'
import ContactMixin from '~/mixins/contact.mixin'

@Component
export default class PhoneNumberLink extends ContactMixin {}
